// third-party
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
    open: false,
    message: ''
};

const slice = createSlice({
    name: 'backdrop',
    initialState,
    reducers: {
        // SET Back Drop Open
        setBackDropOpen(state, action) {
            const { open = false, message = '' } = action.payload;
            state.open = open;
            state.message = message;
        }
    }
});

export const { setBackDropOpen } = slice.actions;

// Reducer
export default slice.reducer;
